import { HttpParams } from "@angular/common/http";
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from "primeng/primeng";
import { QueryOperator } from "../../shared/_utils/services/query-operator.enum";
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { InterimManager } from '../entities/interim-manager';

@Injectable()
export class InterimManagerService extends BaseCrudService<InterimManager> {

  public uri = '/api/interimManager/';

  constructor(injector: Injector){
      super(injector);
     //console.log('Instance InterimManagerService');
  }

  buildSentence(entity?: InterimManager, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.row ? 
          `row${QueryOperator.Equal}${entity.row}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.documentNumber ? 
          `documentNumber${QueryOperator.Contain}${entity.documentNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      ); 
      query = query.concat(
        entity.isInterimManager ? 
          `isInterimManager${QueryOperator.Contain}${entity.isInterimManager}${QueryOperator.Split}`
          : QueryOperator.Empty
      );            
      query = query.concat(
        entity.startDate ? 
          `startDate${QueryOperator.Equal}${entity.startDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      ); 
      query = query.concat(
        entity.dueDate ? 
          `dueDate${QueryOperator.Equal}${entity.dueDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      ); 
      query = query.concat(
        entity.comment ? 
          `comment${QueryOperator.Contain}${entity.comment}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.supportingDocument && entity.supportingDocument.id) {
        query = query.concat(
          `supportingDocument.id${QueryOperator.Equal}${entity.supportingDocument.id}${QueryOperator.Split}`
        );
      }
      if (entity.employee && entity.employee.id) {
        query = query.concat(
          `employee.id${QueryOperator.Equal}${entity.employee.id}${QueryOperator.Split}`
        );
      }
      if (entity.jobTitle && entity.jobTitle.id) {
        query = query.concat(
          `jobTitle.id${QueryOperator.Equal}${entity.jobTitle.id}${QueryOperator.Split}`
        );
      }

      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }    
}


// WEBPACK FOOTER //
// ./src/app/core/services/interim-manager.service.ts